import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

// Attach admin token to requests
api.interceptors.request.use((config) => {
  const url = config.url || "";
  const token = url.startsWith("/admin")
    ? localStorage.getItem("aarmira_admin_token")
    : localStorage.getItem("aarmira_customer_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Resolve product image urls (absolute http OR relative /api/files/..)
export const resolveImg = (url) => {
  if (!url) return undefined;
  if (url.startsWith("http")) return url;
  return `${BACKEND_URL}${url}`;
};

export const formatApiError = (detail) => {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
};

export const inr = (n) => `₹${Number(n).toLocaleString("en-IN")}`;
